import { render } from "./show_certificat.vue?vue&type=template&id=fbd31786&scoped=true"
import script from "./show_certificat.vue?vue&type=script&lang=js"
export * from "./show_certificat.vue?vue&type=script&lang=js"

import "./show_certificat.vue?vue&type=style&index=0&id=fbd31786&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd31786"]])

export default __exports__